export default {
    namespaced: true,

    state: () => {
        return {
            resume: null,
            primaryLenderApplyMode: null,
            applyMode: null,
            data: {},
            selectedPaymentPlan: null,
            isPatient: null,
        }
    },

    mutations: {
        update(state, app) {
            state.data = app
        },

        updateResume(state, resume) {
            state.resume = resume
        },

        updateApplyMode(state, mode) {
            state.applyMode = mode
        },

        updateSelectedPaymentPlan(state, plan) {
            state.selectedPaymentPlan = plan
        },

        updatePrimaryLenderApplyMode(state, mode) {
            state.primaryLenderApplyMode = mode
        },

        updateIsPatient(state, type) {
            state.isPatient = type
        }
    },
}
